export const queryParamsToArray = (href) => {
  // Get the current URL
  const url = new URL(href);
  // Get all the query parameters
  const queryParams = url.searchParams;
  const paramsArray = [];
  for (const [key, value] of queryParams) {
    // Push the key-value pair to the array
    paramsArray.push(`${key}=${value}`);
  }
  return paramsArray
}
export const arrayToQueryParams = (paramsArray) => {
  const queryParams = new URLSearchParams();
  // Iterate over the array and add each key-value pair to the URLSearchParams object
  for (const param of paramsArray) {
    const [key, value] = param.split('=');
    queryParams.append(key, value);
  }

  return queryParams.toString();
}

export const removeDuplicates = (arr) => {
  /* Remove duplicates from array */
  return arr.filter((item,
    index) => arr.indexOf(item) === index);
}


const collectionList = [
  {
    handle: "women",
    secondLevel: [
      "clothing",
      "shoes",
      "bags-accessories"
    ]
  },
  { handle: "jewelry-watches" },
  { handle: 'home-gifts' },
  { handle: 'beauty' },
  {
    handle: "designer",
    secondLevel: [
      "alepel",
      "ellis-brooklyn",
      "carolina-neves"
    ]
  },
  {
    handle: 'collection',
    secondLevel: [
      "bestsellers-clothing"
    ]
  }
]
export const getCollectionName = {
  //type
  "jewelry-watches": "Jewelry & watches",
  "home-gifts": "Home & gifts",
  "bags-accessories": "Bags & accessories",
  //category
  "bath-body": "Bath & body",
  "lingerie-sleepwear": "Lingerie & sleepwear",
  "coats-jackets": "Coats & jackets",
  "dining-entertaining": "Dining & entertaining",
  "socks-tights": "Socks & tights",
  "tools-accessories": "Tools & accessories",
  "gloves-scarves": "Gloves & scarves",
  "wallets-cardholders": "Wallets & cardholders",
  "jumpsuits-rompers": "Jumpsuits & rompers",
  "watch-winders": "Watch winders",
  //subcategory
  "puffer-quilted": "Puffer & quilted",
  "joggers-sweatpants": "Joggers & sweatpants",
  "sweatshirt-hoodies": "Sweatshirt & hoodies",
  "chains-stands": "Chains & strands",
  "mules-slides": "Mules & slides",
  "moisturizer-creams": "Moisturizer & creams",
  "hoops-huggies": "Hoops & huggies",
  "bras-panties": "Bras & panties",
  "loafers-oxfords": "Loafers & oxfords",
  "crossbody-shoulder": "Crossbody & shoulder",
  "Bangles-cuffs": "Bangles & cuffs",
  "double-breasted": "Double-breasted",
  "decorative-pillows-throws": "Decorative pillows & throws",
  "bable-linens-accessories": "Table linens & accessories",
  "candles-home-fragrances": "Candles & home fragrances",
  "hair-masks-treatments": "Hair masks & treatments",
  "office-desk-accessories": "Office & desk accessories",
  "one-piece": "One-Piece",
  "cover-ups": "Cover-Ups",
  "skinny-leg": "Skinny leg",
  "straight-leg": "Straight leg",
  "wide-leg": "Wide leg",
  "tank-cami": "Tank & cami",
  "knee-high": "Knee-high",
  "over-the-knee": "Over-the-knee",
  "cat-eye": "Cat-eye",
  "cleanser-exfoliant": "Cleanser & exfoliant",
  "bar-wine-accessories": "Bar & wine accessories",
  "bowls-trays": "Bowls & trays",
  "fine-jewelry": "Fine jewelry",
  "knee-high-boots": "Knee-high Boots",
  "demi-fine-jewelry": "Demi-fine jewelry",
  "demi-fine-earrings": "Demi-fine earrings",
  "demi-fine-necklaces": "Demi-fine necklaces",
  "demi-fine-rings": "Demi-fine rings",
  "demi-fine-bracelets": "Demi-fine bracelets",
  "demi-fine-anklets": "Demi-fine anklets"
}

//includes designer with special title formatting
export const getDesignersName = {
  "acqua-di-parma": "Acqua di Parma",
  "anna-new-york": "ANNA New York",
  "ark-fine-jewelry": "ARK Fine Jewelry",
  "atp-atelier": "ATP Atelier",
  "az-factory": "AZ Factory",
  "ba-sh": "ba&sh",
  beautystat: "BeautyStat",
  "ben-amun": "Ben-Amun",
  "bird-knoll": "Bird & Knoll",
  bvlgari: "BVLGARI",
  bytimo: "byTiMo",
  caalo: "Caalo",
  "cherut-fine-jewelry": "ChÃ©rut Fine Jewelry",
  "colbert-md": "Colbert MD",
  "d-s-durga": "D.S. & DURGA",
  "derm-institute": "DERM iNSTITUTE",
  "dr-barbara-sturm": "Dr. Barbara Sturm",
  femmue: "FEMMUE",
  healthyline: "HealthyLine",
  heurueh: "HEURUEH",
  "jac-jo": "Jac + Jo",
  "jia-jia": "JIA JIA",
  "joes-jeans": "Joe's Jeans",
  "kimberly-mcdonald": "Kimberly McDonald",
  "l-objet": "L'Objet",
  "la-doublej": "La DoubleJ",
  "lab-to-beauty": "Lab to Beauty",
  "larkspur-hawk": "Larkspur & Hawk",
  lvhr: "LVHR",
  "macrene-actives": "MACRENE Actives",
  marei1998: "Marei1998",
  "mita-eyewear": "MITA Eyewear",
  "mks-jewellery": "MKS Jewellery",
  "mz-skin": "MZ Skin",
  nevernot: "NeverNoT",
  nion: "NION",
  "olympia-le-tan": "Olympia Le-Tan",
  oxomio: "OXOMIO",
  "preen-by-thornton-bregazzi-home": "Preen by Thornton Bregazzi Home",
  "rag-bone": "rag & bone",
  revive: "RÃ©Vive",
  "royce-new-york": "ROYCE New York",
  "s-joon": "S.Joon",
  "sachin-and-babi": "Sachin and Babi",
  semsem: "SemSem",
  "short-suite": "Short & Suite",
  shymi: "SHYMI",
  "sio-beauty": "SiO Beauty",
  "solid-striped": "Solid & Striped",
  strialite: "STRIALITE",
  "stubbs-wootton": "Stubbs & Wootton",
  "r-co": "R+Co",
  "spinelli-kilcollin": "Spinelli Kilcollin",
  "dr-lara-devgan": "Dr. Lara Devgan",
  "dr-loretta": "Dr. Loretta",
  "the-vampires-wife": "The Vampire's Wife",
  "soia-kyo": "Soia & Kyo",
  "maha-morena": "MÃ„HA & MORENA",
  "stripe-stare": "Stripe & Stare",
  "ameon-skin":"AMEŌN Skin",
  "yvonne-leon":"Yvonne Léon",
  "mayle-vasquez":"Maylé Vásquez",
  "verde-limon":"Verde Limón",
  "vahy": "Váhy",
  "latelier-nawbar": "L'Atelier Nawbar",
  "mor%C3%A9-noir": "Moré noir",
  "more-noir": "Moré noir",
  "eera":"EÉRA",
  "e%C3%A9ra": "EÉRA",
  "r%C3%A9gime-des-fleurs": "Régime des Fleurs",
  "regime-des-fleurs": "Régime des Fleurs",
  "casta%C3%B1er": "Castañer",
  "castaner": "Castañer",
  "romu%E1%B9%A1e" : "ROMUṠE",
  "romuse" : "ROMUṠE"
}
/* For a valid collection path check */
export const collectionPath = [
  "women",
  "designer",
  "new-arrivals",
  "search",
  "collection",
  "sale",
  "beauty",
  "jewelry-watches",
  "home-gifts"
]

// check if designer name contains &, - or ^
// function designerNameContainsSpecialChars(str) {
//   const specialChars = `\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`;
//   const result = specialChars.split('').some(specialChar => {
//     if (str.includes(specialChar)) {
//       return true;
//     }
//     return false;
//   });
//   return result;
// }
function formatFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).replaceAll("-", " ");
}

// Creating the query for filter the products
export const createFilterInitialObj = (plpArray, query = '',offset, length) => {
  let isSearch = false;
  let isLevelZero = false;
  let isSale = false;
  if (plpArray.includes('search.json') || plpArray[0] === 'search') {
    isSearch = true;
    plpArray = ['search'];
  }
  // for sale pages.
  if (plpArray[0] === 'sale') {
    /* /sale */
    isSale = true;
    if (plpArray.length > 1) {
      plpArray.shift();
    }
  }

  let finalObj = {}
  let obj = {};
  let initState = {};
  let titleData = {}
  let configure = {
    hitsPerPage: 104,
    filters: 'inventory_quantity>0'
  };
  let indexName = process.env.SHOPIFY_PRIMARY_INDEX;
  /* Women */
  if (plpArray[0] === 'women') {
    isLevelZero = true;
    if (plpArray.length === 1) {
      /* /women */
      configure.filters = `price_ratio=0 AND inventory_quantity>0 AND (named_tags.categories.lvl0:'Clothing' OR named_tags.categories.lvl0:'Shoes' OR named_tags.categories.lvl0:'Bags & accessories')`;
      titleData.plp_header = "Women";
    }
    if (plpArray.length === 2) {
      let level1 = plpArray[1].replaceAll("-", " ");
      let handle = getCollectionName[plpArray[1]] ? getCollectionName[plpArray[1]] : formatFirst(level1)
      obj['refinementList'] = {
        "named_tags.categories.lvl0": [handle]
      }
      titleData.plp_header = handle;
    }
    if (plpArray.length === 3) {
      /* /women/clothing/coats-jackets */
      if (getCollectionName[plpArray[2]]) {
        let level1 = getCollectionName[plpArray[1]] ? getCollectionName[plpArray[1]] : formatFirst(plpArray[1]);
        obj['refinementList'] = {
          "named_tags.categories.lvl0": [level1],
          "named_tags.categories.lvl1": [`${level1} > ${getCollectionName[plpArray[2]]}`],
        }
        titleData.plp_header = getCollectionName[plpArray[2]];
      }
      else {
        let level1 = getCollectionName[plpArray[1]] ? getCollectionName[plpArray[1]] : formatFirst(plpArray[1]);
        let level2 = plpArray[2].replaceAll("-", " ")
        //handlle dynamic paths not included in getCollectionName
        obj['refinementList'] = {
          "named_tags.categories.lvl0": [`${level1}`],
          "named_tags.categories.lvl1": [`${level1} > ${formatFirst(level2)}`]
        }
        titleData.plp_header = formatFirst(level2);
      }
    }
    if (plpArray.length === 4) {
      /*women/shoes/heels/mules-slides */
      if (getCollectionName[plpArray[1]]) {
        let level2 = getCollectionName[plpArray[2]] ? getCollectionName[plpArray[2]] : formatFirst(plpArray[2]);
        let level3 = getCollectionName[plpArray[3]] ? getCollectionName[plpArray[3]] : formatFirst(plpArray[3]);
        obj['refinementList'] = {
          "named_tags.categories.lvl0": [getCollectionName[plpArray[1]]],
          "named_tags.categories.lvl1": [`${getCollectionName[plpArray[1]]} > ${level2}`],
          "named_tags.categories.lvl2": [`${getCollectionName[plpArray[1]]} > ${level2} > ${level3}`]
        }
        titleData.plp_header = level3
      }
      else {
        //handlle dynamic paths not included in getCollectionName
        let level1 = plpArray[1].replaceAll("-", " ")
        let level2 = getCollectionName[plpArray[2]] ? getCollectionName[plpArray[2]] : formatFirst(plpArray[2].replaceAll("-", " "));
        let level3 = getCollectionName[plpArray[3]] ? getCollectionName[plpArray[3]] : formatFirst(plpArray[3].replaceAll("-", " "));
        obj['refinementList'] = {
          "named_tags.categories.lvl0": [`${formatFirst(level1)}`],
          "named_tags.categories.lvl1": [`${formatFirst(level1)} > ${level2}`],
          "named_tags.categories.lvl2": [`${formatFirst(level1)} > ${level2} > ${level3}`]
        }
        titleData.plp_header = level3;
      }
    }
  }

  /* Designers */
  if (plpArray[0] == 'designer' && plpArray.length > 1) {
    // for eg: tom-ford - Tom Ford
    var designerName = plpArray[1].includes("-") ? plpArray[1].split("-").map(name => name.charAt(0).toUpperCase() + name.slice(1)).join(" ") : plpArray[1].charAt(0).toUpperCase() + plpArray[1].slice(1);
    /* /designer/ganni */
    //now the filtering of products on designer plp logic is changed, itwill be filtered via named_tag Vendor
    obj['refinementList'] = {
      "vendor": getDesignersName[plpArray[1]] ? [getDesignersName[plpArray[1]]] : [designerName]
      // "named_tags.Vendor":[plpArray[1]]
    }
    titleData.plp_header = getDesignersName[plpArray[1]] ? getDesignersName[plpArray[1]] : designerName;
  }

  /* new arrival */
  if (plpArray[0] === 'new-arrivals') {
    // /new-arrivals/*
    //if (plpArray.length === 1) {
      isLevelZero = true;
      indexName = process.env.SHOPIFY_NEWEST_FIRST_INDEX;
      configure.hitsPerPage = 102;
      configure.filters = "price_ratio=0 AND inventory_quantity>0  AND (named_tags.Badge:'New')";
      titleData.plp_header = 'New Arrivals';
   // }
    
    // new-arrivals/women
    if (plpArray[1] === 'women') {
      /* /new-arrivals/women/clothing */
      if (plpArray.length === 3) {
        if (getCollectionName[plpArray[2]]) {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [getCollectionName[plpArray[2]]]
          }
          titleData.plp_header = getCollectionName[plpArray[2]];
        }
        else {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [formatFirst(plpArray[2])]
          }
          titleData.plp_header = formatFirst(plpArray[2]);
        }
      }
      /* /new-arrivals/women/clothing/coats-jackets */
      else if (plpArray.length === 4) {
        if (getCollectionName[plpArray[2]]) {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [getCollectionName[plpArray[2]]],
            "named_tags.categories.lvl1": [`${getCollectionName[plpArray[2]]} > ${getCollectionName[plpArray[3]]}`]
          }
          titleData.plp_header = getCollectionName[plpArray[3]];
        }
        else {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [formatFirst(plpArray[2])],
            "named_tags.categories.lvl1": [`${formatFirst(plpArray[2])} > ${formatFirst(plpArray[3])}`]
          }
          titleData.plp_header = formatFirst(plpArray[3]);
        }
      }
      else {
        if (getCollectionName[plpArray[2]]) {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [getCollectionName[plpArray[2]]],
            "named_tags.categories.lvl1": [`${getCollectionName[plpArray[2]]} > ${getCollectionName[plpArray[3]]}`],
            "named_tags.categories.lvl2": [`${getCollectionName[plpArray[2]]} > ${getCollectionName[plpArray[3]]} > ${getCollectionName[plpArray[4]]} `]
          }
          titleData.plp_header = getCollectionName[plpArray[4]];
        }
        else {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [formatFirst(plpArray[2])],
            "named_tags.categories.lvl1": [`${formatFirst(plpArray[2])} > ${formatFirst(plpArray[3])}`],
            "named_tags.categories.lvl2": [`${formatFirst(plpArray[2])} > ${formatFirst(plpArray[3])} > ${formatFirst(plpArray[4])} `]
          }
          titleData.plp_header = formatFirst(plpArray[4]);
        }
      }
    }
    else {
      // new-arrivals/beauty
      if (plpArray.length === 2) {
        if (getCollectionName[plpArray[1]]) {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [getCollectionName[plpArray[1]]]
          }
          titleData.plp_header = getCollectionName[plpArray[1]];
        } else {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [plpArray[1]]
          }
          titleData.plp_header = formatFirst(plpArray[1]);
        }
      }
      // new-arrivals/beauty/fragrance
      else if (plpArray.length === 3) {
        if (getCollectionName[plpArray[1]]) {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [getCollectionName[plpArray[1]]],
            "named_tags.categories.lvl1": [`${getCollectionName[plpArray[1]]} > ${getCollectionName[plpArray[2]]}`]
          }
          titleData.plp_header = getCollectionName[plpArray[2]];
        } else {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [plpArray[1]],
            "named_tags.categories.lvl1": [`${[plpArray[1]]} > ${[plpArray[2]]}`]
          }
          titleData.plp_header = formatFirst(plpArray[2]);
        }
      }
      // new-arrivals/jewellry/fine-jewelry/fine-rings
      else if (plpArray.length === 4) {
        if (getCollectionName[plpArray[1]]) {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [getCollectionName[plpArray[1]]],
            "named_tags.categories.lvl1": [`${getCollectionName[plpArray[1]]} > ${getCollectionName[plpArray[2]]}`],
            "named_tags.categories.lvl2": [`${getCollectionName[plpArray[1]]} > ${getCollectionName[plpArray[2]]} > ${getCollectionName[plpArray[3]]} `]
          }
          titleData.plp_header = getCollectionName[plpArray[3]];
        } else {
          obj['refinementList'] = {
            "named_tags.categories.lvl0": [plpArray[1]],
            "named_tags.categories.lvl1": [`${[plpArray[1]]} > ${[plpArray[2]]}`],
            "named_tags.categories.lvl2": [`${[plpArray[1]]} > ${[plpArray[2]]} > ${[plpArray[3]]} `]
          }
          titleData.plp_header = formatFirst(plpArray[3]);
        }
      }
    }
  }

  

  /* Single direct collection */
  if (plpArray.length === 1 && !isSearch && !isLevelZero && !isSale) {
    /* /home-gifts */
    let level0 = getCollectionName[plpArray[0]] ? getCollectionName[plpArray[0]] : formatFirst(plpArray[0]);
    obj['refinementList'] = {
      "named_tags.categories.lvl0": [level0]
    }
    titleData.plp_header = level0;
  }

  // beauty/fragrance
  if (!plpArray.includes('women') && !plpArray.includes('designer') && !plpArray.includes('new-arrivals') && !plpArray.includes('collection')&& !isSale && plpArray.length === 2) {
    if (getCollectionName[plpArray[1]]) {
      let level0 = getCollectionName[plpArray[0]] ? getCollectionName[plpArray[0]] : formatFirst(plpArray[0].replaceAll("-", " "));
      obj['refinementList'] = {
        "named_tags.categories.lvl0": [level0],
        "named_tags.categories.lvl1": [`${level0} > ${getCollectionName[plpArray[1]]}`]
      }
      titleData.plp_header = getCollectionName[plpArray[1]];
    }
    else {
      let level0 = getCollectionName[plpArray[0]] ? getCollectionName[plpArray[0]] : formatFirst(plpArray[0].replaceAll("-", " "));
      let level1 = formatFirst(plpArray[1].replaceAll("-", " "));
      obj['refinementList'] = {
        "named_tags.categories.lvl0": [`${level0}`],
        "named_tags.categories.lvl1": [`${level0} > ${level1}`]
      }
      titleData.plp_header = level1;
    }
  }

  // jewelry/fine-jewelry/fine-rings
  if (!plpArray.includes('women') && !plpArray.includes('designer') && !plpArray.includes('new-arrivals') && !plpArray.includes('collection') && plpArray.length === 3) {
    if (getCollectionName[plpArray[2]]) {
      let level0 = getCollectionName[plpArray[0]] ? getCollectionName[plpArray[0]] : formatFirst(plpArray[0].replaceAll("-", " "));
      let level1 = getCollectionName[plpArray[1]] ? getCollectionName[plpArray[1]] : formatFirst(plpArray[1].replaceAll("-", " "));
      obj['refinementList'] = {
        "named_tags.categories.lvl0": [level0],
        "named_tags.categories.lvl1": [`${level0} > ${level1}`],
        "named_tags.categories.lvl2": [`${level0} > ${level1} > ${getCollectionName[plpArray[2]]} `]
      }
      titleData.plp_header = getCollectionName[plpArray[2]];
    }
    else {
      let level0 = getCollectionName[plpArray[0]] ? getCollectionName[plpArray[0]] : formatFirst(plpArray[0]);
      let level1 = getCollectionName[plpArray[1]] ? getCollectionName[plpArray[1]] : formatFirst(plpArray[1]);
      let level2 = formatFirst(plpArray[2].replaceAll("-", " "));
      obj['refinementList'] = {
        "named_tags.categories.lvl0": [`${level0}`],
        "named_tags.categories.lvl1": [`${level0} > ${level1}`],
        "named_tags.categories.lvl2": [`${level0} > ${level1} > ${level2} `]
      }
      titleData.plp_header = level2;
    }
  }

  // for /collection pages
  if (plpArray[0] === 'collection') {
    // for eg: round-glasses - Round Glasses
    var collectionName = plpArray[1].split("-").map(name => name.charAt(0).toUpperCase() + name.slice(1)).join(" ");
    /* /collection/bestsellers-clothing */
    configure.filters = `inventory_quantity>0 AND price_ratio=0 AND collections:${plpArray[1]}`;
    titleData.plp_header = getCollectionName[plpArray[1]] ? getCollectionName[plpArray[1]] : collectionName;
  }

  if (isSale) {
    configure.filters = `inventory_quantity>0 AND price_ratio > 0 AND price_ratio < 1 AND tags:'Discounted'`;
    titleData.plp_header =formatFirst(plpArray[0].replaceAll("-", " "));
  }

  // pass offset and length alone with the query to initState
  initState[indexName] = {...obj, offset, length};
  if (isSearch) {
    initState[indexName].query = {query, offset, length};
    configure.filters = "inventory_available:true OR product_type:'Gift Cards'";
    titleData.search_query = query;
  }
  finalObj.initialRefinement = obj;
  finalObj.initState = initState;
  finalObj.configure = configure;
  finalObj.titleData = titleData;
  return finalObj;
}
